import { SectionLoader } from '@/shared/components/section-loader';

export const ScheduledUserLoading = () => {
  return <SectionLoader />;
};
